import React, { useContext } from 'react';
import { Subtitle1, Subtitle2, mergeClasses } from '@fluentui/react-components';

import { I18nContext } from '@bingads-webui-react/i18n-context';

import { NoResultsImage } from './no-results-image';
import { I18n } from './types';
import { useContentNoResultStyles } from './styles';

export const ToolsContentNoResults: React.FC<{
}> = React.memo(() => {
  const i18n: I18n = useContext(I18nContext);
  const classes = useContentNoResultStyles();

  return (
    <div className={mergeClasses('no-results', classes.root)}>
      <NoResultsImage className={classes.noResultsImage} />
      <Subtitle1 block>{i18n.getString(_TL_('We didn\'t find anything'))}</Subtitle1>
      <Subtitle2 block>{i18n.getString(_TL_('Try a different keyword'))}</Subtitle2>
    </div>
  );
});
